import { useEffect, useMemo } from "react";

import { Outlet, useLocation, useNavigate } from "@tanstack/react-router";

import { useEntityTabsStore } from "#store";

import {
	analyticsEntities,
	getDefaultAnalyticsReportKey,
} from "./analyticsConfig";
import { AnalyticsReportNav } from "./components/AnalyticsReportNav";

export const Analytics = () => {
	const navigate = useNavigate();
	const { pathname } = useLocation();

	const setActiveSubTab = useEntityTabsStore(
		(state) => state.setActiveSubTab
	);

	const reportKeys = useMemo(
		() => analyticsEntities.map((entity) => entity.key),
		[]
	);

	const activeReportKey = useMemo(() => {
		const match = pathname.match(/^\/analytics\/(.+?)(?:\/|$)/);
		return match?.[1] ?? "";
	}, [pathname]);

	useEffect(() => {
		if (activeReportKey) {
			setActiveSubTab("analytics", activeReportKey);
		}
	}, [activeReportKey, setActiveSubTab]);

	useEffect(() => {
		if (pathname !== "/analytics") {
			return;
		}
		const target = getDefaultAnalyticsReportKey();
		if (!target) {
			return;
		}
		void navigate({ to: `/analytics/${target}` as "/" });
	}, [pathname, navigate]);

	const handleReportChange = (key: string) => {
		if (!reportKeys.includes(key)) {
			return;
		}
		void navigate({ to: `/analytics/${key}` as "/" });
	};

	return (
		<AnalyticsReportNav
			activeReportKey={activeReportKey}
			onReportChange={handleReportChange}
		>
			<Outlet />
		</AnalyticsReportNav>
	);
};
